module.exports = __webpack_public_path__ + "img/team-mosaic-04.f11aeb4e.jpg";